<template>
  <div>
    <div class="w-100 d-inline-block app-bg-image position-relative">
      <div class="container autoContent">
        <div class="row margin-top-4 margin-bottom-4">
          <div class="col-xl-5 col-12 col-sm-5 
          col-md-5">
            <div class="w-92 d-inline-block mobile-app-image w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <!-- <img class="w-100" src="@/assets/images/mobile-app.webp" alt=""> -->
              <img class="w-100" v-lazy="require('@/assets/images/mobile-app.webp')" alt="Dubai Pets Groomer mobile app">
            </div>
          </div>
          <div class="col-xl-7 col-12 col-sm-7 
          col-md-7">
            <div class="w-100 d-inline-block ps-xl-5">
              <p class="margin-bottom-2 text-size-14 fw-bold nav-color text-uppercase family-filson-bold margin-top-4 text-full-14">
                Get us on your hands
              </p>
              <h2 class="half-black fw-bold text-size-22 text-full-24 family-filson-bold w-92 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2"> 
                Book on the Go with Our Mobile App
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light 
              text-full-13">
                With the Dubai Pet Groomers mobile app, booking a grooming session for your pet is just a tap away
              </p>
            </div>
            <!-- App store buttons hidden until real App Store / Google Play URLs are available -->
            <div v-if="false" class="w-100 d-inline-block app-play-image mb-xl-0 mb-2">
              <a class="d-inline-block" href="#">
                <img v-lazy="require('@/assets/images/google-play-image.svg')" alt="Get it on Google Play">
              </a>
              <a class="d-inline-block ms-3" href="#">
                <img v-lazy="require('@/assets/images/app-store-image.svg')" alt="Download on the App Store">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mobileAppComponent',
}
</script>

<style scoped>

</style>
